import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  imports: [SkeletonModule],
  selector: 'app-skeleton-dash-card',
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
})
export class SkeletonDashCardComponent {}
